<template>
  <div :class="$style.shop_item">
    <div :class="$style.shop_image">
      <AtomsConsumerImage :src="storePcImage" :alt="store.store_name" :class="$style.pc_image" :height="180" />
      <AtomsConsumerImage :src="storeSpImage" :alt="store.store_name" :class="$style.sp_image" :height="223" />
      <div
        v-if="store.label_text"
        :class="$style.shop_label"
        :style="{ color: store.label_color, backgroundColor: store.label_bg_color || 'white' }"
      >
        {{ store.label_text }}
      </div>
    </div>
    <div :class="$style.shop_content">
      <div>
        <div :class="$style.shop_content_head">
          <div :class="$style.label_container">
            <p v-if="store.type === 'official'" :class="$style.store_type_official"> TENTIAL OFFICIAL STORE </p>
            <p v-if="store.type === 'popup'" :class="$style.store_type_popup"> TENTIAL POP UP STORE </p>
          </div>
          <p :class="$style.store_name">{{ store.store_name }}</p>
        </div>
        <div :class="$style.contact">
          <dl :class="[$style.container, $style.address]">
            <dt>Address</dt>
            <dd>
              <p>〒{{ store.post_code }}</p>
              <p :class="$style.shop_address" v-text="store.address"></p>
            </dd>
          </dl>
          <dl v-if="store.tell_number" :class="[$style.container, $style.tel_number]">
            <dt>Tel</dt>
            <dd>
              <AtomsConsumerLink :class="$style.tel" :url="`tel:${store.tell_number}`">
                {{ store.tell_number }}
              </AtomsConsumerLink>
            </dd>
          </dl>
        </div>
      </div>
      <div :class="$style.shop_detail">
        <AtomsConsumerLink :class="$style.link" :url="store.map_url ?? ''" blank>
          <MoleculesConsumerButtonWithArrowRight type="button" variant="secondary" block>
            マップ
          </MoleculesConsumerButtonWithArrowRight>
        </AtomsConsumerLink>
        <AtomsConsumerLink :class="$style.link" :url="`/shop/detail/${store.document_id}`">
          <MoleculesConsumerButtonWithArrowRight type="button" variant="secondary" block>
            店舗詳細
          </MoleculesConsumerButtonWithArrowRight>
        </AtomsConsumerLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { StoreFragment } from "~/types/type.generated"

const props = defineProps<{ store: StoreFragment }>()

const storePcImage = computed(() => {
  const store = props.store
  return store.image && store.image[0] ? store.image[0] : "images/common/no-image.png"
})

const storeSpImage = computed(() => {
  const store = props.store
  return store.image && store.image[0] ? store.image[0] : "images/common/no-image.png"
})
</script>

<style lang="scss" scoped module>
.shop_item {
  width: 100%;
  padding-bottom: 40px;
  border-bottom: 1px solid $primary-20;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @include md {
    flex-wrap: wrap;
    flex-direction: row;
    gap: 50px;
  }
  .shop_image {
    position: relative;
    height: 223px;
    width: 100%;
    @include md {
      height: 180px;
      width: 270px;
    }
    img {
      aspect-ratio: 700 / 455;
      height: 100%;
      width: 100%;
      object-fit: cover;
      @include background-skeleton-loading;
    }
    .pc_image {
      display: none;
      @include md {
        display: block;
      }
    }
    .sp_image {
      display: block;
      @include md {
        display: none;
      }
    }
    .shop_label {
      position: absolute;
      bottom: 0;
      display: inline-block;
      padding: 0 13px;
      font-size: $font-size-10;
      line-height: 2.6;
      white-space: nowrap;
      @include md {
        line-height: 2;
        font-size: $font-size-13;
        padding: 5px 15px;
      }
    }
  }
  .shop_content {
    @include md {
      flex: 1;
      display: flex;
      justify-content: space-between;
    }
    .shop_content_head {
      display: flex;
      align-items: flex-start;
      margin-bottom: 17px;
      flex-direction: column;
      @include md {
        margin-bottom: 26px;
      }
      .label_container {
        .store_type_official,
        .store_type_popup {
          padding: 0 13px;
          font-size: $font-size-10;
          line-height: 2.6;
          margin-bottom: 8px;
          @include md {
            line-height: 2;
            font-size: $font-size-13;
            padding: 5px 15px;
          }
        }
        .store_type_official {
          background-color: $black-20;
        }
        .store_type_popup {
          background-color: $black-20;
        }
      }
      .store_name {
        font-size: $font-size-13;
        line-height: 1.85;
        @include md {
          font-size: $font-size-18;
          line-height: 1.44;
        }
      }
    }
    .contact {
      font-size: $font-size-12;
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 8px 24px;
      margin-bottom: 22px;
      @include md {
        font-size: $font-size-15;
        gap: 20px 38px;
      }
      .container {
        display: contents;
        align-items: center;
        &.tel_number {
          dt {
            align-self: center;
          }
        }
        .tel {
          color: $primary;
          line-height: 1.85;
          text-decoration: underline;
        }
      }
    }
    .shop_detail {
      display: flex;
      align-items: center;
      white-space: nowrap;
      gap: 11px;
      @include md {
        flex-direction: column;
        justify-content: center;
        gap: 10px;
      }
      .link {
        flex: 1;
        @include md {
          flex: inherit;
          width: 100%;
        }
      }
    }
  }
}
</style>
